<!-- `navbar-expand` (no breakpoint): desktop layout at every viewport width,
     same as the main app navbar. -->
<nav class="navbar navbar-expand fixed-top bg-dark">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <a class="navbar-brand nav-environment" href="/">
        <img src="{{ 'BO_LOGO_URL' | translate }}"/>
        <span><br>{{ getClient() }}</span>
      </a>
    </div>

    <ul class="navbar-nav ml-3 mr-2">
      <li class="nav-item">
        @if (langSet.length > 1) {
          <app-lang-switcher></app-lang-switcher>
        }
      </li>
    </ul>
  </div>
</nav>